<p-dialog
  #fastModelo
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar modelo</span>
      <i class="pi pi-fw pi-box ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row p-2">
    <div class="col-md-12 mt-3">
      <span class="p-float-label">
        <input
          id="inputtext-nome"
          class="input-filters"
          pInputText
          [formControl]="form.get('descricao')"
          (blur)="actionFnCheckEntityExist(form.get('descricao'))"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-descricao">Descrição *</label>
      </span>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('duplicate')"
      >
        {{ displayMessage.descricao.duplicate }}
      </small>
      <small class="p-error" *ngIf="form.get('descricao').hasError('required')">
        {{ displayMessage.descricao.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('maxlength')"
      >
        {{ displayMessage.descricao.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('isEmptyValue')"
      >
        {{ displayMessage.descricao.isEmptyValue }}
      </small>
    </div>

    <div class="col-md-12 mt-3">
      <fast-autocomplete
        #input
        id="field-categoria-servicos"
        placeholder="Linha de montagem"
        required
        [domain_id]="tokenService.getDomain().id"
        [autoFirst]="false"
        displayField="descricao"
        [value_order]="'descricao'"
        [pageValue]="'0'"
        [pageSizeValue]="'10'"
        [control]="form.get('linha_producao')"
        (clearSelection)="form.get('linha_producao').reset()"
        [entityService]="linhaProducaoService"
        [actionState]="false"
        [initDataWithEmpty]="true"
        [messages]="{
          required: 'Linha de montagem é obrigatória.',
          typeIs: 'Valor inválido',
          isEmptyValue: 'Inválido: remova os espaços em branco!'
        }"
      ></fast-autocomplete>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        [disabled]="loading"
        (click)="dialogRef.close()"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
